import Notification from "../models/Notification";

const NotificationStore = Notification.create();

export default NotificationStore;
